import styled from "styled-components";

export const Item = styled.span`
    background-color: ${({ theme }) => theme.colors.primary.main};
    color: ${({ theme }) => theme.colors.white};
    padding: 3px 10px;
    border-radius: 5px;
    margin-right:5px;
    white-space: nowrap;
`